import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";

const PolishData = () => {
  const summaryOfFindings = [
    "-Większość polskich słów ma siedem liter.",
    "-Zdecydowanie najczęstszą pierwszą literą polskich słów jest 'p' (na przykład wszystkie przedrostki zaczynające się na tę literę), a następnie 's' i 'z”'.",
    "-Najczęstszymi końcowymi literami polskich słów są samogłoski 'e', 'a' i 'y'.",
    "-Najczęściej występującą literą w polskich słowach jest samogłoska 'a', po której następują samogłoski 'i' i 'e'. Najczęstszą spółgłoską jest 'z', a następnie 'r', i 'n'.",
    "-Wiele z najczęściej używanych polskich słów to zaimki, spójniki i przyimki. Tego typu słów jest jednak w języku polskim bardzo niewiele, dlatego wraz z wydłużaniem się listy najczęściej używanych słów dominować zaczynają rzeczowniki, czasowniki i przymiotniki.",
  ];
  return (
    <div>
      <Header />
      <Container maxWidth="md">
        <Box py={2}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            direction="column"
            alignItems="center"
          >
            <Grid item>
              <Typography
                variant="h4"
                color="black"
                align="center"
                sx={{ marginTop: 6 }}
              >
                CZĘSTOTLIWOŚĆ SŁÓW I LITER W JĘZYKU POLSKIM{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginBottom: 5 }}
              >
                ANALIZA Z WYKORZYSTANIEM PYTHONA (PANDAS I MATPLOTLIB){" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="h7"
                color="black"
                align="left"
                sx={{ fontStyle: "italic" }}
              >
                Ramkę danych wykorzystaną w tej analizie można znaleźć{" "}
                <a href="https://github.com/hermitdave/FrequencyWords/blob/master/content/2016/pl/pl_full.txt">
                  tutaj
                </a>
                . Analiza jest dostępna na licencji open source{" "}
                <a href="https://www.apache.org/licenses/LICENSE-2.0">
                  Apache 2.0
                </a>{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="center">
                - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                - -
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black">
                Ramka danych wykorzystana w tej analizie zawiera{" "}
                <strong>20,000</strong> najczęściej używanych słów w języku
                polskim (co w przybliżeniu odpowiada liczbie słów, które zna
                większość rodzimych użytkowników języka polskiego),
                uszeregowanych według częstotliwości ich występowania w napisach
                filmowych. Na podstawie tych danych w{" "}
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  Tabeli 1
                </Box>{" "}
                poniżej przedstawiono <strong>20</strong> najczęściej
                występujących słów w języku polskim (oraz liczbę ich wystąpień w
                filmach):
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={4} xs={12}>
                <img
                  src="/images/Table1_pl.png"
                  alt="table1"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginTop: 5 }}
              >
                Analiza Długości Słów
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Interesujące byłoby sprawdzenie, ile liter ma przeciętne polskie
                słowo. W tym celu tworzymy w ramce danych nową kolumnę o nazwie
                "LICZBA LITER", która zawiera liczbę liter w każdym z{" "}
                <strong>20 000</strong> słów, z których <strong>20</strong>{" "}
                pierwszych przedstawiono w{" "}
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  Tabeli 2
                </Box>{" "}
                poniżej:
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={5} xs={12}>
                <img
                  src="/images/Table2_pl.png"
                  alt="table2"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Korzystając z funkcji "mean()", możemy teraz obliczyć średnią
                wartość kolumny "LICZBA LITER” i zobaczyć, że przeciętne polskie
                słowo ma <strong>7.12</strong> liter, jak pokazano w poniższym
                przykładzie kodu:
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={5} xs={12}>
                {" "}
                <img
                  src="/images/codesample_pl.png"
                  alt="codesample"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Wykres słupkowy przedstawiający najczęstsze wartości w kolumnie
                "LICZBA LITER" pokazuje zakres długości polskich słów.{" "}
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  Wykres 1
                </Box>{" "}
                poniżej pokazuje, że najwięcej polskich słów (
                <strong>3,381</strong>) ma <strong>siedem</strong> liter (tzn.
                dominantą w kolumnie "LICZBA LITER" jest <strong>siedem</strong>
                ).{" "}
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={8} xs={12}>
                <img
                  src="/images/wykres1.png"
                  alt="figure1"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Poniższy kod ujawnia niektóre z najdłuższych polskich słów,
                które zna większość rodzimych użytkowników języka (oczywiście
                istnieją znacznie dłuższe, bardziej specjalistyczne słowa). Trzy
                najdłuższe słowa wśród <strong>20,000</strong> najczęściej
                używanych to
                <strong>"niebezpieczeństwie"</strong>,{" "}
                <strong>"najprawdopodobniej”</strong> oraz
                <strong>"prawdopodobieństwo"</strong> (wszystkie trzy mają{" "}
                <strong>18</strong> liter).
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={6} xs={12}>
                <img
                  src="/images/codesample1_pl.png"
                  alt="codesample1"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginTop: 5 }}
              >
                Pierwsza Litera Polskich Słów{" "}
              </Typography>
            </Grid>
            <Grid item>
              Interesujące jest również sprawdzenie, od której litery
              najczęściej zaczynają się polskie słowa. W tym celu tworzymy w
              ramce danych kolejną kolumnę o nazwie "PIERWSZA LITERA", jak
              pokazano w{" "}
              <Box component="span" sx={{ textDecoration: "underline" }}>
                Tabeli 3
              </Box>{" "}
              poniżej.
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={5} xs={12}>
                {" "}
                <img
                  src="/images/Table3_pl.png"
                  alt="table3"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              Na tej podstawie tworzymy wykres słupkowy{" "}
              <Box component="span" sx={{ textDecoration: "underline" }}>
                (Wykres 2),{" "}
              </Box>{" "}
              przedstawiający najczęściej występujące pierwsze litery polskich
              słów, i zauważamy, że najczęściej używane słowa w języku polskim
              zaczynają się na literę "p" (<strong>3,073</strong>
              ), a następnie na "s" (<strong>1,869</strong>) i "z" (
              <strong>1,860</strong>). Duża liczba słów zaczynających się na
              literę "p" ma sens, jeśli przypomnimy sobie wszystkie słowa
              rozpoczynające się od przedrostków "przed-”, "po-", "przy-",
              "pod-" oraz wielu innych. Z drugiej strony tylko{" "}
              <strong>sześć</strong> słów zaczyna się na literę "q", na literę
              "x" oraz na literę "y” (wszystkie są słowami obcego pochodzenia),
              a <strong>trzy</strong> słowa zaczynają się na literę "ó"
              (mianowicie zaimek "ów" – nr <strong>3,871</strong>, oraz
              liczebniki "ósmej" – nr <strong>8,008</strong>, i "ósma" – nr{" "}
              <strong>19,085</strong>). Ponadto <strong>żadne</strong> słowa nie
              zaczynają się na litery "ę" ani "ą", stąd ich brak na wykresie.
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={7} xs={12}>
                {" "}
                <img
                  src="/images/Figure2_pl.png"
                  alt="figure2"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginTop: 5 }}
              >
                Ostatnia Litera Polskich Słów{" "}
              </Typography>
            </Grid>
            <Grid item>
              Na podstawie ramki danych możemy również określić, na jakie litery
              najczęściej kończą się najpopularniejsze polskie słowa. W tym celu
              tworzymy w ramce danych kolejną kolumnę o nazwie "OSTATNIA
              LITERA”, jak pokazano w{" "}
              <Box component="span" sx={{ textDecoration: "underline" }}>
                Tabeli 4
              </Box>{" "}
              poniżej.{" "}
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={6} xs={12}>
                {" "}
                <img
                  src="/images/table4_pl.png"
                  alt="lastLetter"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              Następnie sporządzamy wykres słupkowy{" "}
              <Box component="span" sx={{ textDecoration: "underline" }}>
                (Wykres 3)
              </Box>
              , przedstawiający najczęstsze ostatnie litery polskich słów, i
              zauważamy, że polskie słowa najczęściej kończą się na litery "e" (
              <strong>2,654</strong>), "a" (<strong>2,564</strong>) oraz "y" (
              <strong>2,095</strong>). Ma to sens, ponieważ "a" służy do
              zakończenia większości rzeczowników rodzaju żeńskiego, a "e" i "y"
              są często używane w końcówkach liczby mnogiej. Co ciekawe, tylko{" "}
              <strong>jedno</strong> polskie słowo kończy się na literę "q".
              Jednak po dalszej analizie okazało się, że słowo w ramce danych,
              które kończy się na tę literę, jest w rzeczywistości akronimem
              opartym na powszechnie używanym angielskim terminie ("iq" – nr{" "}
              <strong>18,368</strong> na liście).
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={7} xs={12}>
                {" "}
                <img
                  src="/images/Figure3_pl.png"
                  alt="figure3"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginTop: 5 }}
              >
                Częstotliwość Liter w Polskich Słowach{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Kolejną interesującą analizą jest ustalenie — na podstawie listy
                — które litery alfabetu polskiego są najczęściej używane. Możemy
                to zrobić, tworząc w języku Python tablicę dla każdej litery
                alfabetu, w którym każda litera stanowi klucz, a wartością jest
                liczba wystąpień danej litery na liście <strong>20,000</strong>{" "}
                najczęściej używanych polskich słów. Na podstawie nowo
                utworzonej tablicy możemy sporządzić kolejny wykres{" "}
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  (Wykres 4)
                </Box>
                , wykorzystując dwa różne kolory do rozróżnienia samogłosek (na
                czerwono) i spółgłosek (na zielono).
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={7} xs={12}>
                {" "}
                <img
                  src="/images/Figure4_pl.png"
                  alt="figure4"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Wykres pokazuje, że litera "a" jest najczęściej występującą
                literą wśród <strong>20,000</strong> najczęściej używanych
                polskich słów — pojawia się <strong>13,901</strong> razy. Litera
                "q" występuje najrzadziej (w pierwszych <strong>20,000</strong>{" "}
                słów odnotowano ją <strong>9</strong> razy - i tylko w słowach
                pochodzenia obcego).
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Wykres pokazuje również, że "a" (<strong>13,901</strong> razy),
                "i" (<strong>11,121</strong> razy) oraz "e" (
                <strong>10,854</strong> razy) są najczęściej występującymi
                samogłoskami, natomiast samogłoski ze znakami diakrytycznymi
                (np. "ó" - <strong>970</strong> razy) są używane rzadziej.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Spółgłoski "z" (<strong>8,794</strong> razy), "r" (
                <strong>7,271</strong> razy), "n" (<strong>7,046</strong> razy)
                oraz "s" (<strong>5,954</strong> razy) to cztery spółgłoski,
                które najczęściej występują wśród <strong>20,000</strong>{" "}
                najczęściej używanych polskich słów.
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginTop: 5 }}
              >
                Części mowy polskich słów{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Kolejną interesującą analizą jest sprawdzenie, jakimi częściami
                mowy są najczęściej używane słowa w języku polskim. Ramka danych
                nie zawiera informacji o częściach mowy, ale możemy dodać je
                ręcznie dla <strong>500</strong> najczęstszych słów. Na
                podstawie tej nowej kolumny możemy następnie utworzyć kilka
                wykresów kołowych przedstawiających wyniki.
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="h6"
                color="black"
                align="center"
                sx={{ textDecoration: "underline", marginTop: 5 }}
              >
                Części mowy 20 najczęściej używanych polskich słów{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left">
                Wykres kołowy{" "}
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  (Wykres 5)
                </Box>{" "}
                poniżej przedstawia części mowy <strong>20</strong> najczęściej
                używanych słów w języku polskim. (
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  Uwaga:
                </Box>{" "}
                Niektóre słowa mogą należeć do więcej niż jednej części mowy,
                np. "to" i "tak"). W pierwszej dwudziestce znajdują się{" "}
                <strong>dwa przysłówki</strong> (tj. "nie" i "tak"),{" "}
                <strong>sześć zaimków</strong> (tj. "się", "to", "co", "mnie",
                "mi" i "ja"), <strong>pięć spójników</strong> (tj. "i", "że",
                "jak", "a" i "ale"), <strong>jeden czasownik</strong> lub jego
                forma pochodna (tj. "jest") oraz{" "}
                <strong>sześć przyimków</strong> (tj. "w", "na", "z", "do", "o"
                i "za"). Co ciekawe, wśród <strong>20</strong> najczęściej
                używanych polskich słów{" "}
                <strong>nie ma ani rzeczowników, ani przymiotników</strong>.
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={8} xs={12}>
                {" "}
                <img
                  src="/images/Figure5_pl.png"
                  alt="figure5"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography
                variant="h6"
                color="black"
                align="center"
                sx={{ textDecoration: "underline", marginTop: 5 }}
              >
                Części mowy 500 najczęściej używanych polskich słów{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h8" color="black" align="left">
                Po rozszerzeniu listy do <strong>500</strong> najczęściej
                używanych słów wykres kołowy{" "}
                <Box component="span" sx={{ textDecoration: "underline" }}>
                  (Wykres 6)
                </Box>{" "}
                ulega znaczącej zmianie. Rzeczowniki, czasowniki, przymiotniki i
                wykrzykniki stanowią teraz ponad <strong>dwie trzecie</strong>{" "}
                wykresu, podczas gdy przyimki, zaimki i spójniki tworzą{" "}
                <strong>mniejszość</strong>. Ma to sens, ponieważ w języku
                polskim istnieją tysiące rzeczowników, czasowników i
                przymiotników (a ich liczba z roku na rok rośnie), natomiast
                liczba zaimków, przyimków i spójników pozostaje na ogół stała.
                Co ciekawe, najczęściej używanym rzeczownikiem w języku polskim
                jest "czas" (<strong>124</strong>. najczęstsze słowo na liście).
                Technicznie rzecz biorąc, dwie formy rzeczownikowe są jeszcze
                częstsze (nr <strong>94</strong> - "porządku" oraz nr{" "}
                <strong>101</strong> - "domu"), jednak obie występują w
                połączeniu z przyimkiem jako elementy powszechnie używanych
                wyrażeń — "w porządku" oraz "do domu" — stąd ich wyższa pozycja
                na liście najczęściej używanych słów.
              </Typography>
            </Grid>
            <Grid container item justifyContent="center">
              <Grid item md={8} xs={12}>
                {" "}
                <img
                  src="/images/Figure6_pl.png"
                  alt="figure6"
                  style={{ width: "100%" }}
                />
              </Grid>
            </Grid>
            <Grid item>
              <Typography
                variant="h5"
                color="black"
                align="center"
                sx={{ marginTop: 10 }}
              >
                PODSUMOWANIE WNIOSKÓW{" "}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h7" color="black" align="left" p={2}>
                Najważniejsze wnioski z tej analizy są następujące:
              </Typography>
              <List>
                {summaryOfFindings.map((summary) => (
                  <ListItem key={summary}>
                    <ListItemText sx={{ marginLeft: 2 }} primary={summary} />
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};
export default PolishData;
